import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;
  
  // Déterminer le lien du logo en fonction de la page actuelle
  const pathParts = location.pathname.split('/').filter(Boolean);
  const logoLink = (pathParts.length >= 2 && pathParts[0] === 'commune') 
    ? `/commune/${pathParts[1]}` 
    : '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled 
          ? 'bg-white shadow-lg shadow-navy/5' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to={logoLink} className="flex items-center gap-3 group">
            <div className={`w-11 h-11 rounded-xl flex items-center justify-center transition-all duration-300 ${
              isScrolled ? 'bg-navy' : 'bg-white'
            }`}>
              <i className={`ri-drop-fill text-2xl transition-colors ${
                isScrolled ? 'text-white' : 'text-navy'
              }`}></i>
            </div>
            <span className={`font-montserrat font-bold text-xl tracking-tight transition-colors ${
              isScrolled ? 'text-navy' : 'text-white'
            }`}>
              A et F Services
            </span>
          </Link>

          {/* Navigation Links - Desktop */}
          <div className="hidden lg:flex items-center gap-10">
            <Link
              to="/"
              className={`font-inter text-sm font-medium transition-all duration-300 relative whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? isScrolled ? 'text-navy' : 'text-white'
                  : isScrolled
                  ? 'text-neutral-600 hover:text-navy'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              Accueil
              {isActive('/') && (
                <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-accent rounded-full"></span>
              )}
            </Link>
            <Link
              to="/services"
              className={`font-inter text-sm font-medium transition-all duration-300 relative whitespace-nowrap cursor-pointer ${
                isActive('/services')
                  ? isScrolled ? 'text-navy' : 'text-white'
                  : isScrolled
                  ? 'text-neutral-600 hover:text-navy'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              Services
              {isActive('/services') && (
                <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-accent rounded-full"></span>
              )}
            </Link>
          </div>

          {/* CTA Button */}
          <div className="flex items-center gap-4">
            <a
              href="tel:0756848431"
              className="bg-accent hover:bg-accent-dark text-white px-6 py-3 rounded-full font-inter text-sm font-semibold transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg shadow-accent/25 hover:shadow-accent/40 hover:scale-105"
            >
              <i className="ri-phone-fill text-base"></i>
              <span className="hidden sm:inline">Urgence 24/7</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                isScrolled ? 'text-navy hover:bg-neutral-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white rounded-2xl shadow-xl mt-2 p-6 border border-neutral-100">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-inter text-base font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer ${
                  isActive('/') ? 'bg-navy/5 text-navy' : 'text-neutral-600 hover:bg-neutral-50'
                }`}
              >
                Accueil
              </Link>
              <Link
                to="/services"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-inter text-base font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer ${
                  isActive('/services') ? 'bg-navy/5 text-navy' : 'text-neutral-600 hover:bg-neutral-50'
                }`}
              >
                Services
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
